export enum TSVisibilityType {
  Hidden,
  AlwaysVisible,
}
